import { useMemo } from 'react';

import uniq from 'lodash/uniq';

import { Autocomplete, Box } from '@cast/design-system';

import { WorkloadBaseRunningInNode } from 'features/cluster/nodes/types';

import { namespaceCriterion, workloadTypeCriterion } from '../searchCriteria';

import {
  ClearAllButton,
  Search,
  useSearchContext,
  useSearchCriterion,
} from '@cast/shared-search-ui';

const NamespacesFilter = () => {
  const ctx = useSearchContext<WorkloadBaseRunningInNode>();
  const { setValue, value, clear } = useSearchCriterion(namespaceCriterion);
  const namespaces = useMemo(
    () => uniq((ctx?.data || []).map(({ namespace }) => namespace)),
    [ctx?.data]
  );

  return (
    <Autocomplete
      testId="node-details-namespace-filter"
      inputText="Namespace"
      options={namespaces}
      value={value}
      onChange={(value: undefined | typeof namespaces) => {
        if (value?.length) {
          setValue(value);
        } else {
          clear();
        }
      }}
      multiple
      checkable
      size="sm"
    />
  );
};

const WorkloadTypeFilter = () => {
  const ctx = useSearchContext<WorkloadBaseRunningInNode>();
  const { setValue, value, clear } = useSearchCriterion(workloadTypeCriterion);
  const workloadTypes = useMemo(
    () => uniq((ctx?.data || []).map(({ workloadType }) => workloadType)),
    [ctx?.data]
  );

  return (
    <Autocomplete
      testId="node-details-workload-type-filter"
      inputText="Type"
      options={workloadTypes}
      value={value}
      onChange={(value: undefined | typeof workloadTypes) => {
        if (value?.length) {
          setValue(value);
        } else {
          clear();
        }
      }}
      multiple
      checkable
      size="sm"
    />
  );
};

export const Filters = () => {
  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr 200px 200px auto"
      columnGap={8}
    >
      <Search
        size="small"
        placeholder="Search workloads"
        testId="node-details-workloads-search"
      />
      <WorkloadTypeFilter />
      <NamespacesFilter />
      <ClearAllButton
        size="sm"
        testId="node-details-clear-workloads-filters-button"
      />
    </Box>
  );
};
